import { render, staticRenderFns } from "./TicketingNotificationsPanel.vue?vue&type=template&id=7f68c4b2&scoped=true"
import script from "./TicketingNotificationsPanel.vue?vue&type=script&lang=js"
export * from "./TicketingNotificationsPanel.vue?vue&type=script&lang=js"
import style0 from "./TicketingNotificationsPanel.vue?vue&type=style&index=0&id=7f68c4b2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f68c4b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f68c4b2')) {
      api.createRecord('7f68c4b2', component.options)
    } else {
      api.reload('7f68c4b2', component.options)
    }
    module.hot.accept("./TicketingNotificationsPanel.vue?vue&type=template&id=7f68c4b2&scoped=true", function () {
      api.rerender('7f68c4b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/support/TicketingNotificationsPanel.vue"
export default component.exports